/**
 * Radio Tabs
 */
import $ from 'jquery';

$(function () {
    /* Radio Tabs */
    if ($('.radio-tabs').length > 0) {
        $(document).on('change', '.radio-tabs', function () {
            /* Check if target exists */
            if ($($(this).data('target')).length > 0) {
                /* Hide all */
                $($(this).data('target')).parent().find('.tab-pane').removeClass('active');

                /* Show active */
                $($(this).data('target')).addClass('active');

                /* Special case for radio buttons */
                if ($('.check-first').length > 0) {
                    $($(this).data('target') + ' .check-first:first').prop('checked', true);
                }
            }
        });
    }
});
